import React from "react";
import {
  Button,
  Space,
  Row,
  Col,
  message,
  Tooltip,
  Modal,
  Switch,
  Image,
  Avatar,
  Dropdown,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import AlertStore from "../store/AlertStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import AlertAdd from "./AlertAdd";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import AlertAdd2 from "./AlertAdd2";

class AlertList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.alertStore = new AlertStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      showDeleteModal: false,
      ruleId: [],
      releId: "",
      companyVal_Lab: "",
      loadList: 0,

      listDataUpdate: false,
      openRuleDetailsForm: false,
      ruleIdForEdit: "",
      newRuleId: "",
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };

    this.columns = [
      {
        // title: "Rule Id",
        title: context.translate("_FLEET_RULEADMIN_RULELIST_RULEID_"),
        dataIndex: "name",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("alertlist") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Description",
        title: context.translate("_FLEET_DASHBORD_ROUTELIST_DISCRIPTION_"),
        dataIndex: "description",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Cron Rule",
        title: context.translate("_FLEET_RULEADMIN_RULELIST_CRONRULE_"),
        dataIndex: "cronRule",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val) => {
          if (val == 0 || val == "No") {
            return "No";
          } else if (val == 30) {
            return "30 Minute";
          } else if (val == 10080) {
            return "Weekly";
          } else if (val == 5) {
            return "5 Minute";
          } else if (val == 15) {
            return "15 Minute";
          } else if (val == 60) {
            return "Hourly";
          } else if (val == 1440) {
            return "Daily";
          }
        },
      },
      {
        // title: "Active",
        title: context.translate("_FLEET_USER_USERLIST_STATUS_ACTIVE_"),
        dataIndex: "active",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed : 'right',
        width: 10,
        align: "center",
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={
                    record.status == "1"
                      ? this.context.translate("_ACTIVE_")
                      : this.context.translate(
                          "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                        )
                  }
                  placement="top"
                  color={
                    record.status == "1"
                      ? config.activeColor
                      : config.inActiveColor
                  }
                >
                  {this.props.canUpdate("alertlist") && (
                    <Switch
                      // style={{ marginInlineEnd: "10px" }}
                      size="small"
                      className="switch-btn"
                      checked={Number(record.status)}
                      onChange={async (val) => {
                        this.setState({ newRuleId: record.ruleId });
                        this.setState({ isActive: val });
                        this.setState({ showStatusConfirm: true }); // open modal
                      }}
                      // defaultChecked
                    />
                  )}
                </Tooltip>
                {this.props.canDelete("alertlist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "14px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
                <Dropdown
                  // overlayClassName="export-dropdown"
                  menu={this.actionColumn}
                  trigger={["click"]}
                  style={{ cursor: "pointer" }}
                >
                  <Image
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>
              </Space>
            </>
          );
        },
      },
    ];

    this.actionColumn = {
      items: [
        this.props.canUpdate("alertlist") && {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },
      ],
    };
  }

  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });

      await this.alertStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
        isadmin:this.props.getUserData().isadmin,
        userId:this.props.getUserData().userId
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
      await this.setState({ loadList: 1 });
    }
    this.setState({ pageSize: 50 });
  }

  confirmStatus = async (status) => {
    const data = {};

    data.ruleId = this.state.newRuleId;
    data.activeStatus = this.state.isActive === true ? 1 : 0;

    await this.alertStore.updateStatus(data);

    this.setState({ showStatusConfirm: false });
    await this.handleSearch();
  };

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setAlert = this.context.viewStateStore.alertObject;
      if (setAlert.companyId !== "") {
        await this.alertStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: setAlert.companyId,
           isadmin:this.props.getUserData().isadmin,
           userId:this.props.getUserData().userId
        });

        if (Number(this.props.getUserData().isadmin) === -1) {
          let singleData = await this.companyStore.getCompanyDataById(
            setAlert.companyId
          );

          this.setState({
            companyVal_Lab: singleData,
            companyId: setAlert.companyId,
          });
        }
      }
      await this.setState({ listDataUpdate: false });
    }
  }
  async onDelete(record) {
    const response = await this.alertStore.deleteRecord({
      ruleId: record.ruleId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  onEdit = async (record) => {
    const ruleId = record.ruleId;

    if (ruleId) {
      await this.setState({ ruleIdForEdit: ruleId });
      await this.setState({ openRuleDetailsForm: true });
    }
  };

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
      ruleId: [],
    });

    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  async handleSearch() {
    this.setState({ loading: true });

    await this.alertStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      isadmin:this.props.getUserData().isadmin,
      userId:this.props.getUserData().userId
    });
    await this.setState({ loadList: 1 });
  }
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  warningModalVehicle = async () => {
    Modal.warning({
      // title: "Alert",
      title: this.context.translate("_FLEET_DASHBORD_SHOWGEO_REMOVEALERT_"),
      // content: "Please select vehicles",
      content: this.context.translate("_PLEASE_SELECT_VEHICLE_"),
    });
  };

  responseMsg = async (resp) => {
    const isEdit = this.state.ruleIdForEdit;

    if (resp.success == "S") {
      message.success(isEdit ? "Rule Updated" : resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openRuleDetailsForm: false });
      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };
  closeModal = () => {
    this.setState({ openRuleDetailsForm: false, ruleId: "" });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                  // allowClear={true}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              {this.props.canCreate("alertlist") && (
                <Button
                  className="addButtonClass"
                  onClick={async () => {
                    await this.setState({
                      openRuleDetailsForm: true,
                      ruleId: "",
                      ruleIdForEdit: "",
                    });
                  }}
                >
                  <Image
                    style={{ width: 13, marginInlineEnd: "5px" }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.alertStore?.total}
            columns={this.columns}
            dataSource={this.alertStore?.alertData}
            loading={this.alertStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_CONFIRM_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showStatusConfirm: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              {this.state.isActive === true ? (
                <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
              ) : (
                <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
              )}
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showStatusConfirm: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() => this.confirmStatus()}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}
        {/* {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={this.context.translate("_CONFIRM_")}
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            //footer={null}
            onOk={this.confirmStatus}
            onCancel={() => {
              this.setState({ showStatusConfirm: false });
            }}
            width={400}
          >
            {this.state.isActive === true ? (
              <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
            ) : (
              <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
            )}
          </Modal>
        )} */}

        {this.state.openRuleDetailsForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal" //  {/* css class */}
          //   // title="Rule Details"
          //   title={this.context.translate("_FLEET_RULEADMIN_RULEDETAIL_TITLE_")}
          //   centered
          //   open={this.state.openRuleDetailsForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openRuleDetailsForm: false, ruleId: "" });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="alertFormDrawer uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openRuleDetailsForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_FLEET_RULEADMIN_RULEDETAIL_TITLE_")}
                <p className="formDescription">
                  {this.context.translate("_ALERT_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openRuleDetailsForm: false })}
            onCancel={() =>
              this.setState({ openRuleDetailsForm: false, ruleId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <AlertAdd2
                ruleId={this.state.ruleIdForEdit}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
AlertList.contextType = StoreContext;
export default observer(withRouter(AlertList));
